/*
 * Inventory Action Button Container connets the Inventory Action Button to redux
 */

import {
    bulkUpdateInstalls,
    setEnableInstallBatchMode,
    startBulkUpdateInstallProduct,
    toggleEditInstallModal,
    toggleSearchNewProductsModal,
    toggleEditJobDefaultsModal,
    toggleCommissioningDataFormModal,
    toggleModalSignaturePad,
    getReportPreview,
    getReportPreviewInline,
    toggleModalAddFSE,
    toggleModalEditFacilityContacts
} from '../../actions/manageInventoryActions';
import { completeJob, toggleEditJobModal, unlinkWorkOrders } from '../../actions/manageJobActions';

import { passSelected, startBulkCannotCompleteSelected } from '../../actions/measurementPointResultsActions';
import {
    toggleJobSignatureModal,
    toggleAddHoursModal,
    toggleWorkOrderCloseModal,
    toggleConfirmSelectJobModal,
    toggleIsJobClosingWithSignature,
    hideJobClosingWithSignature,
    toggleIsCollectingSignatures
} from '../../actions/workOrderActions';

import { IinitialState } from '../../reducers';
import { IinstallBasePopulated, IjobPopulated } from '../../models';
import { InventoryActionButton } from './InventoryActionButton';
import { RouteComponentProps } from 'react-router';
import { TFunction } from 'i18next';
import { connect } from 'react-redux';
import { jobStatusEnum } from '../../models-enums';
import { jobTypesIdEnum } from '../../models-enums';
import { selectIsLoading } from '../../reducers/commonReducers';
import { selectIsJobReadOnly } from '../../reducers/commonSelectors';
import { countriesWithJobDefaults } from '../../constants/constants';
import { getIsWorkOrderTypeJob } from '../../reducers/manageJobReducer';

interface Iprops extends RouteComponentProps<any> {
    t: TFunction;
    colorButton: string;
    installBasesPopulated: IinstallBasePopulated[];
    resetSelection: () => void;
    hideVirtualDecommissioned?: boolean;
    onHideVirtualChange?: (checked: boolean) => void;
}

const mapStateToProps = (state: IinitialState, ownProps: Iprops) => {
    const { user } = state;
    const { selectedJob } = state.manageJob;
    const isAssignedOrApprover =
        selectedJob.assignedUserID === state.user.id ||
        (selectedJob.approverID != null && selectedJob.approverID === state.user.id);
    const showCompleteJobButton =
        isAssignedOrApprover && selectedJob.status !== jobStatusEnum.completed;
    const isAdditionalFSE =
        (selectedJob as IjobPopulated).userJobs?.some(uj => !uj.isDeleted && uj.userID === state.user.id) ??
        false;
    const showReportPreviewButton =
        (isAssignedOrApprover || isAdditionalFSE) && selectedJob.status !== jobStatusEnum.completed;
    const { jobTypeID } = selectedJob;
    const isAuditJob = jobTypeID === jobTypesIdEnum.audit;
    const isCommissioningJob = jobTypeID === jobTypesIdEnum.commissioning;
    const isMaintenanceJob = jobTypeID === jobTypesIdEnum.maintenance;
    const isRepairJob = jobTypeID === jobTypesIdEnum.repair;
    const isVerificationJob = jobTypeID === jobTypesIdEnum.verification;
    const isWarrantyJob = jobTypeID === jobTypesIdEnum.warrantyBM;
    const isAgsJob = jobTypeID === jobTypesIdEnum.agsRebalancing;
    const isAnnualJob = jobTypeID === jobTypesIdEnum.inspection;
    const isServicePlanJob = jobTypeID === jobTypesIdEnum.servicePlan;

    const jobFacility = state.facilities.facilitiesByID[selectedJob.facilityID];

    const showEditJobDefaultsButton =
        jobTypeID === jobTypesIdEnum.inspection &&
        jobFacility &&
        countriesWithJobDefaults.includes(jobFacility.countryID);

    const workOrders = state.workOrder.workOrdersByID;
    const installBaseParts = state.parts.installBasePartsByID;
    const isWorkOrder = getIsWorkOrderTypeJob(state);

    return {
        loading: selectIsLoading(state),
        showCompleteJobButton,
        showReportPreviewButton,
        showEditJobDefaultsButton: showEditJobDefaultsButton || false,
        selection: state.manageInventory.selection,
        isAuditJob,
        isCommissioningJob,
        isMaintenanceJob,
        isRepairJob,
        isVerificationJob,
        isWarrantyJob,
        isServicePlanJob,
        isAgsJob,
        isAnnualJob,
        isWorkOrder,
        selectedJob,
        isJobReadOnly: selectIsJobReadOnly(state),
        online: state.offline.online,
        workOrders,
        installBaseParts,
        user
    };
};

export const InventoryActionButtonContainer = connect(mapStateToProps, {
    toggleEditJobModal,
    toggleSearchNewProductsModal,
    passSelected,
    startBulkCannotCompleteSelected,
    completeJob,
    toggleEditInstallModal,
    setEnableInstallBatchMode,
    startBulkUpdateInstallProduct,
    bulkUpdateInstalls,
    toggleWorkOrderCloseModal,
    toggleAddHoursModal,
    toggleConfirmSelectJobModal,
    toggleEditJobDefaultsModal,
    toggleJobSignatureModal,
    toggleModalSignaturePad,
    toggleIsJobClosingWithSignature,
    hideJobClosingWithSignature,
    toggleIsCollectingSignatures,
    toggleCommissioningDataFormModal,
    getReportPreview,
    getReportPreviewInline,
    unlinkWorkOrders,
    toggleModalAddFSE,
    toggleModalEditFacilityContacts
})(InventoryActionButton);
